import { useFormContext } from "react-hook-form";
import { AddCommentsForm } from "./AddCommentsForm";
import { ChangeStageComment } from "../../../../types/pipeline";

interface Props {
    displayFechaVisitaInput?: boolean;
}

export function DefaultStageForm({ displayFechaVisitaInput }: Props) {
    const { register, formState: { errors }} = useFormContext<ChangeStageComment>();

    return (
        <div>
            {displayFechaVisitaInput && (
            <div>
                <label className="text-sm font-semibold">Fecha de Visita</label>
                <input 
                    {...register("fechaVisita")}
                    className="
                        w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                        font-semibold text-gray-600 text-sm"
                    type="datetime-local" />
            </div>
            )}

            <AddCommentsForm
                register={register}
                errors={errors} />
        </div>
    );
}
